import { render, staticRenderFns } from "./violatediscipline.vue?vue&type=template&id=33a1aea6&scoped=true&"
import script from "./violatediscipline.vue?vue&type=script&lang=js&"
export * from "./violatediscipline.vue?vue&type=script&lang=js&"
import style0 from "./violatediscipline.vue?vue&type=style&index=0&id=33a1aea6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a1aea6",
  null
  
)

export default component.exports